import o from"styled-components";const t=o.div`
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 40px;
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	background-color: ${({accentColor:o})=>o};
	border-radius: ${({borderRadius:o})=>o}px;
	color: ${({textColor:o})=>o};
	box-sizing: border-box;
	height: 100%;
`,i=o.div`
	font-size: 56px;
	font-weight: 500;
	line-height: 110%;
	min-height: 56px;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
	overflow: hidden;
	text-overflow: ellipsis;

	& > div[contenteditable] {
		padding-bottom: 1px;
	}
`,e=o.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,l=o.p`
	all: unset;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 120%;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,r=o.div`
	display: grid;
	place-content: center;
	width: 40px;
	height: 40px;

	svg {
		width: 40px;
		height: 40px;

		fill: ${({color:o})=>o};

		path,
		circle {
			fill: ${({color:o})=>o};
		}
	}
`,p=o.div`
	position: relative;
	font-size: 40px;
	cursor: pointer;

	&::after {
		content: '';
		position: absolute;
		display: block;
		width: 24px;
		height: 9px;
		background-color: rgba(0, 0, 0, 0.15);
		border-radius: 9999px;
		filter: blur(5px);
		top: 100px;
		left: 20%;
	}
`;export{t as CardContainer,e as CardContentContainer,p as CardEmoji,i as CardNumber,l as CardParagraph,r as IconContainer};
